<p-button [disabled]="!editable" icon="pi pi-trash" styleClass="standard-button" *ngIf="isDeletable()"
    (onClick)="onDeleteClick()"  class="p-button-outlined" label="{{!isFractionGrid ? 'Delete': ''}}"></p-button>